import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const customerServiceGetStartedEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-customer-service-get-started" */ './src'),
	),
	getPreloadProps: () => ({}),
});
